<app-listagem-obras
    title="Minhas Obras"
    [subtitle]="'(' + totalItems + ')'"
    [descriptionSubtitle]="'Obras atribuídas diretamente a você para acompanhamento e gestão comercial.'"
    [data]="obras"
    [pageSize]="pageSize"
    [totalItems]="totalItems"
    [page]="page"
    (pageChange)="onPageChange($event)"
    (sortChange)="ordenarPor($event.column)"
    (selectionChange)="onSelectionChange($event)"
    (pageSizeChange)="onPageSizeChange($event)"
    (tiposSelecionadosChange)="onTiposObraSelecionadosChange($event)"
      (abrirFichaObra)="abrirDetalhesObra($event)"
    (downloadPdf)="downloadPDFFicha()"
    (imprimir)="impressaoFicha()"
   (abrirEmpresa)="onAbrirEmpresa($event)"
    [loading]="loadingWorks"
    [selectedRows]="selectedRows"
    [searchType]="searchType"
    [searchTerm]="searchTerm"
    (searchTypeChange)="onSearchTypeChange($event)"
    (searchTermChange)="onSearchTermChange($event)"
    (searchEnter)="onSearchEnter()"
    [updateInterval]="updateInterval"
    (updateIntervalChange)="onUpdateIntervalChange($event)"

  ></app-listagem-obras>

<app-common-loader *ngIf="loadingWorks"></app-common-loader>
